import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import styles from "./CalibrationRequestForm.module.scss";

const InfoTooltip = ({ text, imageSrc }) => {
  const [visible, setVisible] = useState(false);

  return (
    <span
      className={styles.infoTrigger}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onClick={() => setVisible((v) => !v)}
    >
      <FaInfoCircle />
      {visible && (
        <span className={styles.infoPopup}>
          {imageSrc && <img src={imageSrc} alt="info" className={styles.infoImage} />}
          {text && <span>{text}</span>}
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
